(function () {
  var STYLE_ID = 'mr-countdown-styles';
  var ROOT_SELECTOR = '[data-mr-countdown]';
  var timers = new WeakMap();

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.mr-countdown{margin:10px 0}',
      '.mr-countdown[hidden]{display:none!important}',
      '.ccd-widget{background:#fff;border:1px solid #000;border-radius:0;padding:14px 16px 12px}',
      '.ccd-head{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px;gap:12px}',
      '.ccd-label{font-weight:600;font-size:14px;color:#333;flex:1}',
      '.ccd-timer-wrap{text-align:right;flex-shrink:0}',
      '.ccd-timer{font-size:22px;font-weight:800;letter-spacing:0;font-variant-numeric:tabular-nums;line-height:1.1}',
      '.ccd-timer-sub{font-size:10px;color:#aaa;font-weight:500;margin-top:2px}',
      '.ccd-bar-wrap{position:relative!important;height:8px!important;background:#e0e0e0!important;border-radius:0!important;margin-bottom:8px!important}',
      '.ccd-bar-fill{display:block!important;height:100%!important;min-height:8px!important;border-radius:0!important;position:absolute!important;left:0!important;top:0!important;transition:width .8s ease,background .4s ease}',
      '.ccd-dot-wrap{position:absolute;top:50%;transform:translate(-50%,-50%);transition:left .8s ease}',
      '.ccd-dot{width:12px;height:12px;border-radius:50%;position:relative}',
      '.ccd-pulse{position:absolute;inset:-4px;border-radius:50%;opacity:0}',
      '@keyframes ccd-pulse{0%{opacity:.5;transform:scale(.6)}80%{opacity:0;transform:scale(2)}100%{opacity:0;transform:scale(2)}}',
      '.ccd-footer{font-size:11px;color:#aaa;display:flex;align-items:center;gap:4px;flex-wrap:wrap;line-height:1.4}',
      '.ccd-info-btn{display:inline-flex;align-items:center;justify-content:center;width:15px;height:15px;border-radius:50%;background:#ddd;color:#888;font-size:10px;font-weight:700;cursor:pointer;flex-shrink:0;border:none;font-style:normal;user-select:none;-webkit-user-select:none;transition:background .15s,color .15s}',
      '.ccd-info-btn:hover{background:#bbb;color:#fff}',
      '.ccd-info-btn.active{background:#555;color:#fff}',
      '.ccd-expand{overflow:hidden;max-height:0;opacity:0;margin-top:0;transition:max-height .3s ease,opacity .3s ease,margin .3s ease}',
      '.ccd-expand.open{max-height:160px;opacity:1;margin-top:8px}',
      '.ccd-expand-inner{background:#f7f7f7;border-left:3px solid #ccc;border-radius:0;padding:9px 11px;font-size:12px;color:#555;line-height:1.55;transition:border-color .3s ease}',
      '.ccd-expand-inner strong{color:#222}'
    ].join('');
    document.head.appendChild(style);
  }

  function asNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function readConfig(root) {
    var dataset = root.dataset;

    return {
      cutoffHour: asNumber(dataset.cutoffHour, 11),
      cutoffMinute: asNumber(dataset.cutoffMinute, 45),
      vacationFrom: asNumber(dataset.vacationFrom, 0),
      vacationUntil: asNumber(dataset.vacationUntil, 0),
      show: dataset.showCountdown === 'true',
      externalFulfillment: dataset.externalFulfillment === 'true',

      pickupDays: {
        1: dataset.pickupMonday === 'true',
        2: dataset.pickupTuesday === 'true',
        3: dataset.pickupWednesday === 'true',
        4: dataset.pickupThursday === 'true',
        5: dataset.pickupFriday === 'true',
        6: dataset.pickupSaturday === 'true'
      },

      polishHolidays: (dataset.polishHolidays || '')
        .split(',')
        .map(function (value) { return value.trim(); })
        .filter(Boolean),

      locale: dataset.locale || 'de',

      strings: {
        todayNormal: dataset.textTodayNormal || '',
        todayUrgent: dataset.textTodayUrgent || '',
        todayCritical: dataset.textTodayCritical || '',
        tomorrow: dataset.textTomorrow || '',
        monday: dataset.textMonday || '',
        footerActive: dataset.textFooterActive || '',
        footerStatic: dataset.textFooterStatic || '',
        tooltipToday: dataset.textTooltipToday || '',
        tooltipNext: dataset.textTooltipNext || '',
        timerSublabel: dataset.textTimerSublabel || '',
        minSublabel: dataset.textMinSublabel || '',
        shippingDay: dataset.textShippingDay || ''
      }
    };
  }

  function getElements(root) {
    return {
      root: root,
      title: root.querySelector('[data-ccd-title]'),
      timer: root.querySelector('[data-ccd-timer]'),
      timerSub: root.querySelector('[data-ccd-timer-sub]'),
      bar: root.querySelector('[data-ccd-bar]'),
      dotWrap: root.querySelector('[data-ccd-dot-wrap]'),
      dot: root.querySelector('[data-ccd-dot]'),
      pulse: root.querySelector('[data-ccd-pulse]'),
      footer: root.querySelector('[data-ccd-footer]'),
      expand: root.querySelector('[data-ccd-expand]'),
      expandInner: root.querySelector('[data-ccd-expand-inner]'),
      tooltipText: root.querySelector('[data-ccd-tooltip-text]'),
      infoBtn: root.querySelector('[data-ccd-info-btn]')
    };
  }

  function berlinNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
  }

  function localIsoDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function isPolishHoliday(date, config) {
    return config.polishHolidays.indexOf(localIsoDate(date)) !== -1;
  }

  function isShippingDay(date, config) {
    var day = date.getDay();

    // Sonntag grundsätzlich kein Versand.
    if (day === 0) return false;

    // Polnische Feiertage gelten für Fulfillment UND Eigenlager.
    if (isPolishHoliday(date, config)) return false;

    // Fulfillment: Montag bis Freitag.
    if (config.externalFulfillment) {
      return day >= 1 && day <= 5;
    }

    // Eigenlager: ausschließlich aktivierte Abhol-/Versandtage.
    return config.pickupDays[day] === true;
  }

  function nextBusinessDay(date, config) {
    var result = new Date(date);

    for (var i = 0; i < 21; i++) {
      if (isShippingDay(result, config)) return result;
      result.setDate(result.getDate() + 1);
    }

    return result;
  }

  function computeWindow(now, config) {
    function windowFor(shipDate) {
      var start = new Date(shipDate);
      start.setDate(shipDate.getDate() - 1);
      start.setHours(17, 0, 0, 0);

      var end = new Date(shipDate);
      end.setHours(config.cutoffHour, config.cutoffMinute, 0, 0);

      return { start: start, end: end, ship: shipDate };
    }

    var base = nextBusinessDay(now, config);
    var firstWindow = windowFor(base);
    if (now >= firstWindow.start && now < firstWindow.end) return firstWindow;

    var nextDate = new Date(base);
    nextDate.setDate(nextDate.getDate() + 1);
    var secondWindow = windowFor(nextBusinessDay(nextDate, config));
    if (now >= secondWindow.start && now < secondWindow.end) return secondWindow;

    return null;
  }

  function isVacation(config) {
    if (!config.vacationFrom || config.vacationFrom <= 0) return false;

    var nowSec = Math.floor(Date.now() / 1000);
    if (!config.vacationUntil || config.vacationUntil <= 0) {
      return nowSec >= config.vacationFrom;
    }

    return nowSec >= config.vacationFrom && nowSec <= config.vacationUntil;
  }

  function formatDate(date, locale) {
    return date.toLocaleDateString(locale === 'de' ? 'de-DE' : 'en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  }

  function applyColor(elements, color) {
    elements.title.style.color = color;
    elements.timer.style.color = color;
    elements.dot.style.background = color;
    elements.pulse.style.background = color;
    elements.expandInner.style.borderLeftColor = color;
  }

  function setVisible(elements, visible) {
    elements.root.hidden = !visible;
  }

  function render(root) {
    var config = readConfig(root);
    var elements = getElements(root);
    var strings = config.strings;

    if (!elements.title || !elements.timer || !elements.infoBtn) return;

    // Urlaub betrifft nur Eigenlager.
    // Fulfillment läuft unabhängig davon weiter.
    if (!config.show || (!config.externalFulfillment && isVacation(config))) {
      setVisible(elements, false);
      return;
    }

    var now = berlinNow();

    var activeWindow = computeWindow(now, config);

    setVisible(elements, true);

    if (activeWindow) {
      var diff = activeWindow.end - now;
      var totalMs = activeWindow.end - activeWindow.start;
      var frac = Math.max(0.02, Math.min(1, diff / totalMs));
      var hours = Math.floor(diff / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var isUrgent = diff <= 6 * 3600000;
      var isCritical = diff <= 1 * 3600000;
      var isSameDay = activeWindow.ship.toDateString() === now.toDateString();
      var isMonday = activeWindow.ship.getDay() === 1 && !isSameDay;
      var color;
      var barBg;
      var pulseDur;

      if (isCritical) {
        color = '#c62828';
        barBg = '#c62828';
        pulseDur = '0.7s';
      } else if (isUrgent) {
        color = '#e65100';
        barBg = 'linear-gradient(to right, #ffcc80, #e65100)';
        pulseDur = '1.1s';
      } else {
        color = '#2e7d32';
        barBg = 'linear-gradient(to right, #a5d6a7, #43a047)';
        pulseDur = '1.8s';
      }

      elements.title.textContent = isSameDay
        ? isCritical
          ? strings.todayCritical
          : isUrgent
            ? strings.todayUrgent
            : strings.todayNormal
        : isMonday
          ? strings.monday
          : strings.tomorrow;

      elements.timer.textContent =
        isCritical || hours === 0
          ? mins + ' min'
          : hours + 'h ' + String(mins).padStart(2, '0') + 'm';

      elements.timer.style.fontSize = '22px';
      elements.timerSub.textContent =
        isCritical || hours === 0
          ? strings.minSublabel
          : strings.timerSublabel;

      elements.bar.style.background = barBg;
      elements.bar.style.width = frac * 100 + '%';
      elements.dotWrap.style.left = frac * 100 + '%';
      elements.pulse.style.animation =
        'ccd-pulse ' + pulseDur + ' ease-out infinite';
      elements.footer.textContent = strings.footerActive;
      elements.tooltipText.textContent =
        isSameDay ? strings.tooltipToday : strings.tooltipNext;

      applyColor(elements, color);
      return;
    }

    // Außerhalb eines aktiven Countdown-Fensters
    // keinen statischen Balken anzeigen.
    // Das gilt für Fulfillment und Eigenlager gleichermaßen.
    setVisible(elements, false);
    return;
  }

  function destroy(root) {
    var timer = timers.get(root);
    if (!timer) return;

    clearInterval(timer.interval);
    window.removeEventListener('resize', timer.onResize);
    timer.infoBtn?.removeEventListener('click', timer.onInfoClick);
    timers.delete(root);
  }

  function init(scope) {
    injectStyles();

    var context = scope || document;
    var roots = [];

    if (context.matches && context.matches(ROOT_SELECTOR)) {
      roots.push(context);
    }

    if (context.querySelectorAll) {
      roots = roots.concat(
        Array.from(context.querySelectorAll(ROOT_SELECTOR))
      );
    }

    roots.forEach(function (root) {
      destroy(root);

      var elements = getElements(root);

      var onResize = function () {
        render(root);
      };

      var onInfoClick = function () {
        var open = elements.expand.classList.toggle('open');

        elements.infoBtn.classList.toggle('active', open);
        elements.infoBtn.setAttribute(
          'aria-expanded',
          open ? 'true' : 'false'
        );
      };

      elements.infoBtn?.addEventListener('click', onInfoClick);

      render(root);

      timers.set(root, {
        interval: setInterval(function () {
          render(root);
        }, 60000),
        onResize: onResize,
        onInfoClick: onInfoClick,
        infoBtn: elements.infoBtn
      });

      window.addEventListener('resize', onResize);
    });
  }

  window.MRCountdown = {
    init: init,
    destroy: destroy,
    render: render
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();